
import Modal from '@mui/material/Modal';
import Card from '@mui/material/Card';
import Grid from '@mui/material/Grid';
import MDBox from 'components/MDBox';
import MDTypography from 'components/MDTypography';
import MDButton from 'components/MDButton';
import DashboardLayout from 'examples/LayoutContainers/DashboardLayout';
import DashboardNavbar from 'examples/Navbars/DashboardNavbar';
import DataTable from 'components/Tables/DataTable';
import moment from 'moment';


import { useEffect, useState, useCallback, useRef } from 'react';
import ProgressBar from 'pantallas/Comprobantes/components/ProgressBar/ProgressBar';
import Acciones from './components/Acciones';
import GuardarPago from './guardarPago/GuardarPago';
import {
	iMiEmpresaInfoToPDF,
	initMiEmpresaFormulario,
} from 'actions/MiCuenta/miCuentaTypes';
import { useSelector } from 'react-redux';
import { RootStore } from 'store/Store';
import { getEmpresaInfoById } from 'actions/MiCuenta/miCuenta';

import { useDispatch } from 'react-redux';
import { numeroAMoneda } from 'helpers/aMoneda';
import { getComprobantesCP } from 'actions/Comprobante/comprobante';
import PXLoader from 'components/PXLoader/PXLoader';
import { CSVLink } from 'react-csv';
import { IconButton, Tooltip } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import MDPagination from 'components/MDPagination';
import Icon from '@mui/material/Icon';
import { axiosClient, getToken } from 'Config/axiosConfig';
import { START_LOADING, LOADING_END } from 'actions/Loading/loadingTypes';

function Pago(props: any): JSX.Element {
	const dispatch = useDispatch();
const { empresa_id } = useSelector((state: RootStore) => state.auth);
const { loading } = useSelector((state: RootStore) => state.loading);
const [datos, setDatos] = useState([]);
const [page, setPage] = useState(1);
const [limit, setLimit] = useState(10);
const [total, setTotal] = useState(0);
const [search, setSearch] = useState('');

	const [titulo, setTitulo] = useState('');
	const [open, setOpen] = useState(false);
	const [modo, setModo] = useState(0);
	const [id, setId] = useState(0);

const [miEmpresa, setMiEmpresa] = useState<iMiEmpresaInfoToPDF>(
    initMiEmpresaFormulario
);
const [comprobanteToUpdate, setComprobanteToUpdate] = useState();
const [exportRows, setExportRows] = useState<any[]>([]);
const [exportOpen, setExportOpen] = useState(false);
const [exporting, setExporting] = useState(false);
const csvRef = useRef<any>(null);

	const handleClose = (event?: object,reason?:string) => {
		if (reason && reason == "backdropClick")return;
		setOpen(false);
		setComprobanteToUpdate(null);
	};
	const handleOpen = () => setOpen(!open);

	const modoModal = (modo: number, item: { id: number }) => {
		setModo(modo);
		setId(item.id);
		setTitulo(modo === 0 ? 'Agregar Pago' : 'Actualizar Pago');
		handleOpen();
	};
const isMyDataValid = () => {
    // Validar únicamente los campos obligatorios por SAT para PDF/CFDI
    if (!miEmpresa.nombre) return false;
    if (!miEmpresa.rfc) return false;
    if (!miEmpresa.regimen_fiscal) return false;
    if (!miEmpresa.codigo_postal) return false;

    return true;
};

//Estuctura de datos para tabla
	const datosTabla = {
		columns: [
			{ Header: 'UUID', accessor: 'UUID', width: '80px', align: 'center' },
			{ Header: 'Serie', accessor: 'Serie', width: '80px', align: 'center' },
			{ Header: 'Folio', accessor: 'Folio', width: '80px' },
			{ Header: 'Clientes', accessor: 'Cliente', width: '230px' },
			{ Header: 'Fecha pago', accessor: 'FechaPago', width: '100px' },
			{ Header: 'Monto pagado', accessor: 'MontoPagado' },
			{ Header: 'Estatus', accessor: 'Estatus' },
			{ Header: 'Acciones', accessor: 'Acciones' },
		],
		rows: datos
			.map((item) => {
				return {
					UUID: item.uuid,
					Serie: item.serie,
					Folio: item.folio,
					Cliente: item.nombre,
					FechaPago: (
						<>
							<span
								style={{
									display: 'flex',
									maxWidth: '105px',
									marginLeft: '-10px',
								}}
							>
								{item.complementoPagos[0] && item.complementoPagos[0].fecha_pago
									? moment(item.complementoPagos[0].fecha_pago).format('DD/MM/YYYY')
									: '--/--/--'}
							</span>
						</>
					),
					MontoPagado: (
						<>
							<span
								style={{
									display: 'flex',
									width: '125px',
								}}
							>
								{item.complementoPagos[0] && item.complementoPagos[0].monto
									? numeroAMoneda(item.complementoPagos[0].monto)
									: '$ __.__'}
							</span>
						</>
					),
					Estatus: (
						<>
							<ProgressBar progressId={item.estatus_comprobante_id} />
						</>
					),
					Acciones: (
						<>
							<Acciones
								item={item}
								setDatos={setDatos}
								isMyDataValid={isMyDataValid}
								modoModal={modoModal}
								setComprobanteToUpdate={setComprobanteToUpdate}
							/>
						</>
					),
				};
			}),
	};

	// Construye filas CSV para Pagos
	const buildCsvRows = (items: any[]) =>
		items.map((d: any) => {
			const fechaPago = d?.complementoPagos?.[0]?.fecha_pago || '';
			const montoPagado = d?.complementoPagos?.[0]?.monto
				? numeroAMoneda(d.complementoPagos[0].monto)
				: '';
			if (d.estatus_comprobante_id === 1) {
				return {
					serie: d.serie,
					Folio: d.folio,
					Uuid: d.uuid,
					Cliente: d.nombre,
					FechaPago: fechaPago,
					MontoPagado: montoPagado,
					Estatus: 'Cancelado',
				};
			}
			if (d.estatus_comprobante_id === 2) {
				return {
					serie: d.serie,
					Folio: d.folio,
					Uuid: d.uuid,
					Cliente: d.nombre,
					FechaPago: fechaPago,
					MontoPagado: montoPagado,
					Estatus: 'Creado',
				};
			}
			if (d.estatus_comprobante_id === 3) {
				return {
					serie: d.serie,
					Folio: d.folio,
					Uuid: d.uuid,
					Cliente: d.nombre,
					FechaPago: fechaPago,
					MontoPagado: montoPagado,
					Estatus: 'Timbrado',
				};
			}
			if (d.estatus_comprobante_id === 4) {
				return {
					serie: d.serie,
					Folio: d.folio,
					Uuid: d.uuid,
					Cliente: d.nombre,
					FechaPago: fechaPago,
					MontoPagado: montoPagado,
					Estatus: 'Timbrado & Enviado',
				};
			}
			return {
				serie: d.serie,
				Folio: d.folio,
				Uuid: d.uuid,
				Cliente: d.nombre,
				FechaPago: fechaPago,
				MontoPagado: montoPagado,
				Estatus: d.estatus_comprobante_id,
			};
		});

	const openExportModal = () => setExportOpen(true);
	const closeExportModal = () => { if (!exporting) setExportOpen(false); };

	const exportCurrentPage = () => {
		setExportRows(buildCsvRows(datos));
    setTimeout(() => csvRef.current?.link?.click(), 0);
		setExportOpen(false);
	};

	const exportAllPages = async () => {
		try {
			setExporting(true);
			const all: any[] = [];
			let p = 1;
			const size = 200;
			for (;;) {
				const resp = await axiosClient.get(`/comprobantes`, {
					params: { tipo_comprobante_id: 7, page: p, limit: size, q: search },
				});
				const payload = resp.data;
				const pageData = Array.isArray(payload) ? payload : (payload?.data || []);
				all.push(...pageData);
				if (Array.isArray(payload)) break;
				const totalPages = payload?.meta?.totalPages || 1;
				if (p >= totalPages) break;
				p += 1;
			}
			setExportRows(buildCsvRows(all));
    setTimeout(() => csvRef.current?.link?.click(), 0);
		} catch (e) {
			console.error('Error al exportar CSV', e);
		} finally {
			setExporting(false);
			setExportOpen(false);
		}
	};

	//Get mi EmpresaInfo
	useEffect(() => {
		if (empresa_id) {
			const dataEmpresa = getEmpresaInfoById(empresa_id);
			dataEmpresa
				.then((respuesta) => {
					if (respuesta.status === 200) {
						setMiEmpresa(respuesta.data);
					}
				})
				.catch((error) => {
					if (error.response.status === 500) {
						console.log('error500');
						console.log(error.response.data.message);
					} else if (error.response.status === 400) {
						console.log('error400');
						console.log(error.response.data.message);
					} else if (error.response.status === 403) {
						console.log('error403');
						console.log(error.response.data.message);
					} else if (error.response.status === 404) {
						console.log('error404');
						console.log(error.response.data.message);
					} else {
						console.log(error.response.data.message);
					}
				});
		}
	}, [empresa_id]);

// Obtener complementos de pago paginados
const fetchPagos = useCallback(() => {
	return async (dispatch: any) => {
		await getToken();
		dispatch({ type: START_LOADING });
		axiosClient
			.get(`/comprobantes`, { params: { tipo_comprobante_id: 7, page, limit, q: search } })
			.then((respuesta) => {
				const payload = respuesta.data;
				if (Array.isArray(payload)) {
					setDatos(payload);
					setTotal(payload.length);
				} else {
					setDatos(payload?.data || []);
					setTotal(payload?.meta?.total || 0);
				}
				dispatch({ type: LOADING_END });
			})
			.catch((error) => {
				console.log(error?.response?.data || error?.message);
				setDatos([]);
				dispatch({ type: LOADING_END });
			});
	};
}, [page, limit, search]);

useEffect(() => {
	dispatch<any>(fetchPagos());
}, [fetchPagos, dispatch]);

	return (
		<DashboardLayout>
			<DashboardNavbar />
			<MDBox pt={6} pb={3}>
				<Card>
					<MDBox p={3} lineHeight={1}>
						<Grid
							container
							direction='row'
							justifyContent='flex-end'
							alignItems='flex-end'
						>
							<MDButton
								size='small'
								color='primary'
								onClick={() => modoModal(0, { id: 0 })}
							>
								+ Agregar
							</MDButton>
							<MDButton size='small' sx={{ marginLeft: '5px', border: '1px solid' }} onClick={openExportModal}>
								+ Exportar CSV
							</MDButton>
                            <CSVLink data={exportRows} filename='Pagos.csv' ref={csvRef as any} style={{ display: 'none' }} />
						</Grid>
						<MDTypography variant='h5' fontWeight='medium' color='primary'>
							Complementos de pago
						</MDTypography>
					</MDBox>
					<DataTable table={datosTabla} canSearch isSorted={false} entriesPerPage={false} showTotalEntries={false} onServerSearch={(val: string) => { setPage(1); setSearch(val); }} />
					<MDBox display={'flex'} justifyContent={'space-between'} alignItems={'center'} p={2}>
						<MDTypography variant='button' color='secondary' fontWeight='regular'>
							Mostrando {datos.length} de {total} registros
						</MDTypography>
						<MDPagination>
							{page > 1 && (
								<MDPagination item onClick={() => setPage(1)}>
									<Icon sx={{ fontWeight: 'bold' }} style={{ marginLeft: '2px' }}>chevron_left</Icon>
									<Icon sx={{ fontWeight: 'bold' }} style={{ marginLeft: '-10px' }}>chevron_left</Icon>
								</MDPagination>
							)}
							{page > 1 && (
								<MDPagination item onClick={() => setPage(page - 1)}>
									<Icon sx={{ fontWeight: 'bold' }}>chevron_left</Icon>
								</MDPagination>
							)}
							<MDTypography variant='caption' color='secondary' sx={{ mx: 2 }}>
								Página {page} de {Math.max(Math.ceil(total / limit), 1)}
							</MDTypography>
							{page < Math.max(Math.ceil(total / limit), 1) && (
								<MDPagination item onClick={() => setPage(page + 1)}>
									<Icon sx={{ fontWeight: 'bold' }}>chevron_right</Icon>
								</MDPagination>
							)}
							{page < Math.max(Math.ceil(total / limit), 1) && (
								<MDPagination item onClick={() => setPage(Math.max(Math.ceil(total / limit), 1))}>
									<Icon sx={{ fontWeight: 'bold' }} style={{ marginLeft: '2px' }}>chevron_right</Icon>
									<Icon sx={{ fontWeight: 'bold' }} style={{ marginLeft: '-10px' }}>chevron_right</Icon>
								</MDPagination>
							)}
						</MDPagination>
					</MDBox>
					{loading && (
						<>
							<MDBox m={4}>
								<PXLoader />
							</MDBox>
						</>
					)}
				</Card>
			</MDBox>

			{/* Modal de Exportación */}
			<Modal
				open={exportOpen}
				onClose={closeExportModal}
				aria-labelledby='export-modal-title'
				aria-describedby='export-modal-description'
				style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
			>
				<MDBox sx={{ position: 'relative', width: 420, maxWidth: '95vw', bgcolor: 'background.paper', borderRadius: 2, boxShadow: 24, p: 3 }}>
					<MDTypography variant='h6' id='export-modal-title' mb={1}>Exportar CSV</MDTypography>
					<MDTypography variant='button' color='secondary' id='export-modal-description'>
						Elige qué exportar. Filtro actual: {search ? `'${search}'` : 'ninguno'}
					</MDTypography>
					<MDBox mt={3} display='flex' gap={1} justifyContent='flex-end'>
						<MDButton variant='outlined' color='secondary' disabled={exporting} onClick={exportCurrentPage}>
							Descargar página actual
						</MDButton>
						<MDButton variant='gradient' color='primary' disabled={exporting} onClick={exportAllPages}>
							{exporting ? 'Preparando…' : 'Descargar todas las páginas'}
						</MDButton>
					</MDBox>
				</MDBox>
			</Modal>
			<Modal
				open={open}
				onClose={handleClose}
				aria-labelledby='modal-modal-title'
				aria-describedby='modal-modal-description'
				style={{
					display: 'flex',
					alignItems: 'center',
					justifyContent: 'center',
					zIndex: '19000',
				}}
			>
				<MDBox sx={style.Modal}>
				<Tooltip title='Cerrar' >
					<IconButton onClick={()=>handleClose()} color="secondary"  aria-label="upload picture" component="label" style={{position:'absolute',top:'3px',right:'3px', backgroundColor:'#fff',border:'1px solid #00ACC8'}}>
						<CloseIcon />
					</IconButton>
				</Tooltip>
					<GuardarPago
						handleOpen={handleOpen}
						modo={id}
						setDatos={setDatos}
						comprobanteToUpdate={comprobanteToUpdate}
					/>
				</MDBox>
			</Modal>
		</DashboardLayout>
	);
}
const style = {
	Modal: {
		position:'relative',
		width: '90%',
		maxWidth: '1200px',
		height: '95vh',
		bgcolor: 'background.paper',
		boxShadow: 24,
		p: 4,
		overflow: 'auto',
		borderRadius: '10px',
	},
	EspacioTitulo: {
		marginTop: '1rem',
		marginBottom: '1rem',
	},
};
export default Pago;
